// removed by extract-text-webpack-plugin
module.exports = {"Alert":"Alert__Alert___Qmerw","AlertRed":"Alert__AlertRed___279sL"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Alert/Alert.less
// module id = 1106
// module chunks = 0 1